var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "attachContainer" },
      [
        _c("div", { staticClass: "item" }, [_vm._v("附件列表：")]),
        _vm._l(_vm.attachments, function(item) {
          return _c(
            "div",
            { staticClass: "item", attrs: { Key: item.Key } },
            [
              _vm.format.estimateIsImage(item.Path)
                ? _c("viewer", [
                    item.Path
                      ? _c("img", {
                          key: item.Path,
                          staticStyle: { height: "30px", width: "30px" },
                          attrs: { src: _vm.baseUrl + item.Path }
                        })
                      : _vm._e()
                  ])
                : _vm._e(),
              _c("span", { staticStyle: { "font-size": "14px" } }, [
                _c(
                  "a",
                  {
                    attrs: { href: _vm.baseUrl + item.Path, target: "_blank" }
                  },
                  [_vm._v(" " + _vm._s(item.Name))]
                )
              ])
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }